(() => {
  if (window.axiologyCollectionNavigation || !document.querySelector('.axiology-category-nav')) return;
  window.axiologyCollectionNavigation = true;
  const nav = document.querySelector('.axiology-category-nav');
  const wrapper = nav.closest('.row--product-list');
  if (!wrapper) return;
  const cache = new Map();
  const pending = new Map();
  const suffixes = ['__banner', '__sort', '__filters', '__content', '__banner-bottom'];
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  let generation = 0;
  const status = document.createElement('span');
  status.setAttribute('role', 'status');
  status.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);';
  nav.append(status);
  const normalize = href => {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname)) return null;
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.hash = '';
    return url;
  };
  const extract = doc => {
    const root = doc.querySelector('.row--product-list');
    if (!root?.querySelector('.axiology-category-nav') || !root.querySelector('.product__list')) throw new Error('Unsupported collection template');
    return {
      title: doc.title,
      canonical: doc.querySelector('link[rel="canonical"]')?.href,
      description: doc.querySelector('meta[name="description"]')?.content || '',
      sections: suffixes.map(suffix => {
        const node = [...root.children].find(el => el.id.endsWith(suffix));
        if (!node) throw new Error('Missing collection section');
        return {id: node.id, html: node.outerHTML};
      })
    };
  };
  const remember = (key, data) => {
    cache.set(key, {data, time: Date.now()});
    while (cache.size > 12) cache.delete(cache.keys().next().value);
    return data;
  };
  const load = url => {
    const key = url.href;
    const existing = cache.get(key);
    if (existing && Date.now() - existing.time < 60000) return Promise.resolve(existing.data);
    if (pending.has(key)) return pending.get(key);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const request = fetch(key, {signal: controller.signal, credentials: 'same-origin'})
      .then(response => {
        if (!response.ok || new URL(response.url).pathname !== url.pathname) throw new Error('Collection load failed');
        return response.text();
      })
      .then(html => remember(key, extract(new DOMParser().parseFromString(html, 'text/html'))))
      .finally(() => { clearTimeout(timeout); pending.delete(key); });
    pending.set(key, request);
    return request;
  };
  const setActive = url => nav.querySelectorAll('a').forEach(link => {
    if (new URL(link.href).pathname === url.pathname) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
  const navigate = async (url, push = true) => {
    const run = ++generation;
    wrapper.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading products';
    try {
      const data = await load(url);
      if (run !== generation) return;
      const replacements = data.sections.map(section => {
        const target = document.getElementById(section.id);
        if (!target || !wrapper.contains(target)) throw new Error('Different template');
        const template = document.createElement('template');
        template.innerHTML = section.html;
        return {target, node: template.content.firstElementChild};
      });
      // Never replace the site header, category navigation, or cart drawer.
      replacements.forEach(({target, node}) => target.replaceWith(node));
      if (push) history.pushState({...history.state, axiologyCollection: true}, '', url);
      document.title = data.title;
      if (data.canonical) document.querySelector('link[rel="canonical"]')?.setAttribute('href', data.canonical);
      document.querySelector('meta[name="description"]')?.setAttribute('content', data.description);
      setActive(url);
      if (typeof BoosterTheme !== 'undefined') BoosterTheme.events.trigger('booster:content:update', {trigger: 'collection-navigation'});
      document.dispatchEvent(new CustomEvent('axiology:collection:change', {detail: {url: url.href}}));
      window.dataLayer?.push({event: 'axiology_collection_navigation', page_location: url.href, page_title: data.title});
      status.textContent = 'Products updated';
    } catch (error) {
      if (run === generation) location.assign(url.href);
    } finally {
      if (run === generation) wrapper.removeAttribute('aria-busy');
    }
  };
  try { remember(normalize(location.href).href, extract(document)); } catch (error) { return; }
  document.addEventListener('click', event => {
    const link = event.target.closest('.axiology-category-nav a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = normalize(link.href);
    if (!url) return;
    event.preventDefault();
    navigate(url);
  });
  // Capture before the theme's inline sort handler, so history remains coherent.
  document.addEventListener('change', event => {
    if (event.target.id !== 'sort-by' || !wrapper.contains(event.target)) return;
    const url = normalize(location.href);
    if (!url) return;
    event.stopImmediatePropagation();
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    navigate(url);
  }, true);
  window.addEventListener('popstate', () => {
    const url = normalize(location.href);
    if (url) navigate(url, false);
    else location.reload();
  });
  const prefetch = event => {
    const link = event.target.closest?.('.axiology-category-nav a');
    const url = link && normalize(link.href);
    if (url) load(url).catch(() => {});
  };
  nav.addEventListener('pointerover', prefetch);
  nav.addEventListener('focusin', prefetch);
  nav.addEventListener('touchstart', prefetch, {passive: true});
  // Warm a bounded set of categories, one request at a time, after initial work.
  const warmCategories = async () => {
    if (navigator.connection?.saveData) return;
    for (const link of [...nav.querySelectorAll('a')].slice(0, 8)) {
      if (document.hidden) break;
      const url = normalize(link.href);
      if (url) await load(url).catch(() => {});
    }
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(warmCategories, {timeout: 3000});
  else setTimeout(warmCategories, 1500);
})();
